import { styled } from '@mui/material/styles';
import { Box, Toolbar, IconButton, Container, Stack, Typography, DialogContent, DialogActions } from '@mui/material';

// Root layout container
export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflow: 'hidden',
  backgroundImage:
    'radial-gradient(circle at 20% 20%, rgba(34,211,238,0.14), transparent 26%), radial-gradient(circle at 80% 0%, rgba(124,58,237,0.12), transparent 22%), linear-gradient(145deg, #0b1021 0%, #0f172a 45%, #0a0f1d 100%)',
}));

// Header toolbar with spaced sections
export const Header = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(1.5, 2),
}));

// Left section within AppBar
export const LeftSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

// Right section within AppBar
export const RightSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

// Menu button in header
export const MenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

// Settings button with optional spin animation
export const SettingsButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'animate',
})(({ theme, animate }) => ({
  transition: 'transform 0.3s ease-in-out',
  '&:hover': { transform: 'rotate(30deg)' },
  animation: animate ? 'spin 0.5s ease-in-out' : 'none',
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(180deg)' },
  },
}));

// Main content container
export const Main = styled(Container)(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  overflow: 'auto',
}));

// Layout stack for panels
export const Content = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  gap: theme.spacing(3),
}));

// Column for TimerPanel
export const Column = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isTablet' && prop !== 'isMobile',
})(({ theme, isTablet, isMobile }) => ({
  display: 'block',
  flexGrow: isTablet ? 0 : 1,
  ...isMobile && { fontSize: "1rem"},
}));

// Wrapper for desktop menu items
export const DesktopMenu = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

// Default dialog content with responsive padding and dynamic height
export const DefaultDialogContent = styled(DialogContent, { shouldForwardProp: (prop) => prop !== 'isMobile' })(
  ({ theme, isMobile }) => ({
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: { padding: theme.spacing(3) },
    height: isMobile ? 'calc(100vh - 64px)' : 'auto',
    overflow: 'auto',
  })
);

// Default dialog actions with responsive padding and zero top padding
export const DefaultDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: { padding: theme.spacing(3) },
  paddingTop: 0,
}));

// Settings modal content with no padding and hidden overflow
export const SettingsDialogContent = styled(DialogContent)(() => ({
  padding: 0,
  overflow: 'hidden',
}));

// Statistics dialog content with smaller responsive padding
export const StatsDialogContent = styled(DialogContent, { shouldForwardProp: (prop) => prop !== 'isMobile' })(
  ({ theme, isMobile }) => ({
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: { padding: theme.spacing(2) },
    [theme.breakpoints.up('md')]: { padding: theme.spacing(3) },
    height: isMobile ? 'calc(100vh - 64px)' : 'auto',
    overflow: 'auto',
  })
);

// Statistics dialog actions with smaller responsive padding and zero top padding
export const StatsDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.up('sm')]: { padding: theme.spacing(2) },
  paddingTop: 0,
}));
